import cookie from '../plugins/jquery.cookie.js';
import Headroom from '../plugins/headroom.js';

jQuery(function($) {
  // Sticky Header
  var myElement = document.querySelector(".global-header");
  var headroom  = new Headroom(myElement, {
    "offset": 150,
    "tolerance": 0
  });
  headroom.init();

  $('.bio-toggle').click(function(){
    $(this).parents('.staff-member').toggleClass('open');
  });

  const SVG_PLUS = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
  <path class="vertical-line" d="M7.07104 0V14.1421" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
  <path d="M-2.2769e-05 7.07107H14.1421" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
</svg>`;

function initMobileNav() {
  const nav = document.getElementById("mobile-navigation");
  if (!nav) return;

  // Only direct children of #mobile-navigation, not nested sub-menu parents
  const parents = Array.from(nav.children).filter(el =>
    el.classList.contains("menu-item-has-children")
  );

  if (parents.length === 0) return;

  parents.forEach((item) => {
    const link = item.querySelector(":scope > a");
    if (!link) return;

    // Don't double-inject if already initialised
    if (item.querySelector(":scope > .submenu-toggle")) return;

    const btn = document.createElement("button");
    btn.className = "submenu-toggle";
    btn.setAttribute("aria-label", "Toggle submenu");
    btn.innerHTML = SVG_PLUS;

    // Wrap <a> + <button> in a flex row
    const row = document.createElement("div");
    row.className = "menu-item-row";
    link.parentNode.insertBefore(row, link);
    row.appendChild(link);
    row.appendChild(btn);

    const toggleItem = () => {
      const isOpen = item.classList.contains("is-open");
      parents.forEach((s) => s.classList.remove("is-open"));
      if (!isOpen) item.classList.add("is-open");
    };

    // Link navigates freely, never toggles the submenu
    // Button solely controls the submenu
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      toggleItem();
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMobileNav);
} else {
  // DOM already ready (e.g. script is deferred or loaded at bottom of body)
  initMobileNav();
}

  // Btn Arrows
  const svgMarkup = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18" fill="none" class="btn-icon">
      <g clip-path="url(#clip0_btn_arrow)">
        <path d="M0.772941 9.77773H30.0981V8.22218H0.772941V9.77773Z" fill="#0057AB"/>
        <path d="M22.454 17.6259L30.99 9.03729L29.8512 7.89153L21.3153 16.4802L22.454 17.6259Z" fill="#0057AB"/>
        <path d="M29.8469 10.1827L30.9857 9.03694L22.4497 0.448295L21.311 1.59406L29.8469 10.1827Z" fill="#0057AB"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4497 0.264404L29.8492 7.70963L29.8512 7.70764L31.1727 9.03729L22.454 17.8098L21.1325 16.4802L27.665 9.90736H0.643311V8.09255H27.5868L21.1282 1.59406L22.4497 0.264404Z" fill="#0057AB"/></g>
      <defs>
        <clipPath id="clip0_btn_arrow">
          <rect width="32" height="18" fill="white"/>
        </clipPath>
      </defs>
    </svg>`;

  document.querySelectorAll('.btn').forEach(btn => {
    if (!btn.querySelector('.btn-icon')) {
      const text = btn.textContent.trim();
      const words = text.split(/\s+/);
      const lastWord = words.pop();
      const rest = words.join(' ');

      btn.innerHTML = (rest ? rest + ' ' : '') +
        `<span class="nowrap">${lastWord}${svgMarkup}</span>`;
    }
  });

  $('.accordion-toggle').click(function(){
    $(this).parents('.accordion').toggleClass('open');
  });

  $('#footer-navigation').append('<li class="menu-item"><a class="search-toggle" href="#search"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M11 11L17 17" stroke="#343333" stroke-width="2" stroke-miterlimit="10"/><path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="#343333" stroke-width="2" stroke-miterlimit="10"/></svg> Search</a></li>')

  function resizeCtaBg() {
    $('section.ctas .bg-image').each(function () {
      var $bg = $(this);
      var $inner = $bg.parents('.inner');
      var $right = $bg.siblings('.right-ctas');

      var innerHeight = $inner.outerHeight() || 0;
      var rightHeight = $right.outerHeight() || 0;

      $bg.css('height', innerHeight - rightHeight - 100);
    });
  }

  $(document).ready(function () {
    resizeCtaBg();
  });

  $(window).on('load resize', function () {
    resizeCtaBg();
  });

  // Search
  (function () {
    var input = document.getElementById('search-input');
    var btn = document.querySelector('#search-form .btn');
    var BREAKPOINT = 768; // adjust if needed
    var arrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18" fill="none" class="btn-icon"><g clip-path="url(#clip0_btn_arrow)"><path d="M0.772941 9.77773H30.0981V8.22218H0.772941V9.77773Z" fill="#0057AB"/><path d="M22.454 17.6259L30.99 9.03729L29.8512 7.89153L21.3153 16.4802L22.454 17.6259Z" fill="#0057AB"/><path d="M29.8469 10.1827L30.9857 9.03694L22.4497 0.448295L21.311 1.59406L29.8469 10.1827Z" fill="#0057AB"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.4497 0.264404L29.8492 7.70963L29.8512 7.70764L31.1727 9.03729L22.454 17.8098L21.1325 16.4802L27.665 9.90736H0.643311V8.09255H27.5868L21.1282 1.59406L22.4497 0.264404Z" fill="#0057AB"/></g><defs><clipPath id="clip0_btn_arrow"><rect width="32" height="18" fill="white"/></clipPath></defs></svg>';

    function update() {
      if (window.innerWidth < BREAKPOINT) {
        input.placeholder = 'Keyword…';
        btn.innerHTML = arrowSVG;
      } else {
        input.placeholder = 'Enter keyword…';
        btn.innerHTML = 'Search' + arrowSVG;
      }
    }

    update();
    window.addEventListener('resize', update);
  })();
  $('.search-toggle').click(function(e){
    e.preventDefault();
    $('#search-popup').toggleClass('active');
    $('#search-input').focus();
  });
  $('.close-search').click(function(){
    $('#search-popup').removeClass('active');
  });

  // Alert Bar
  $('.close-alert-bar').on('click', function(){
    $('.alert-bar').css('display', 'none');
    $.cookie('alert', $('.alert-bar').attr('id'), { path: '/' });
  });

  // Pagination
  $('#pagination').on('click', 'a', function(e){
    e.preventDefault();
    $(this).remove();
    $('#ajax-loader').load($(this).attr('href') + ' #ajax-posts>*', function(){
      $('#ajax-posts').append($('#ajax-loader').html());
    });
    $('#pagination').load($(this).attr('href') + ' #pagination>*');
  });

  // Anchor
  $('a').on('click', function(e){
    var $href = $(this).attr('href');
    if ($href.match('^#') && !$(this).hasClass('accordion-tab')) {
      e.preventDefault();
      $('html, body').stop().animate({
          scrollTop: $($href).offset().top
      });
    }
  });

  // Form Labels
  $('input').on('focus', function(){
    $(this).parent('*').addClass('filled');
  });
  $('input').on('blur', function(){
    if ($(this).val() !== '') {
      $(this).parent('*').addClass('filled');
    } else {
      $(this).parent('*').removeClass('filled');
    }
  });

  // Video popups
  $('a').on('click', function(e){
    var $target = $(this).attr('href');
    if ($target.toLowerCase().indexOf("vimeo") >= 0) {
      e.preventDefault();
      var $n = $target.lastIndexOf('/');
      var $vid = $target.substring($n + 1);
      $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
      $('.video-popup-wrapper').addClass('active');
      $('body, html').addClass('body-noscroll');
    }
    if ($target.toLowerCase().indexOf("youtu") >= 0) {
      e.preventDefault();
      var $y = $target.lastIndexOf('=');
      var $yid = $target.substring($y + 1);
      $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
      $('.video-popup-wrapper').addClass('active');
      $('body, html').addClass('body-noscroll');
    }
  });
  $('.close-popup').on('click', function(){
    $('.video-popup-wrapper').removeClass('active');
    $('.popup-content').html('');
    $('body, html').removeClass('body-noscroll');
  });

  // Mobile Nav
  var $scrollposition = 0;
  $('#mobile-nav-toggle').on('click', function(){
    if ($(this).hasClass('active')) {
      $('body, html').removeClass('nav-locked');
      $(window).scrollTop($scrollposition);
    } else {
      $scrollposition = $(window).scrollTop();
      $('body, html').addClass('nav-locked');
      $(window).scrollTop(0);
    }
    $('#mobile-navigation-wrapper').toggleClass('active');
    $(this).toggleClass('active');
  });

  (function () {
    const params = new URLSearchParams(window.location.search);

    // ── Part 1: Search results page ──────────────────────────────────────────
    // Append ?term=<query> to every article link inside .search-posts
    const query = (params.get('s') || '').trim();

    if (query) {
      const links = document.querySelectorAll('.search-posts .search-post a.link');
      links.forEach(function (a) {
        const url = new URL(a.href, window.location.origin);
        url.searchParams.set('term', query);
        a.href = url.toString();
      });
    }

    // ── Part 2: Any page with ?term= ─────────────────────────────────────────
    // Highlight matching text anywhere in <main>, or fall back to <body>
    const term = (params.get('term') || '').trim();

    if (!term) return;

    const container = document.querySelector('main') || document.body;

    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex   = new RegExp(`(${escaped})`, 'gi');

    function walkTextNodes(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (!regex.test(node.textContent)) return;
        regex.lastIndex = 0;

        const frag = document.createDocumentFragment();
        let last = 0, match;

        while ((match = regex.exec(node.textContent)) !== null) {
          if (match.index > last) {
            frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
          }
          const mark = document.createElement('mark');
          mark.className = 'search-highlight';
          mark.textContent = match[0];
          frag.appendChild(mark);
          last = regex.lastIndex;
        }

        if (last < node.textContent.length) {
          frag.appendChild(document.createTextNode(node.textContent.slice(last)));
        }

        node.parentNode.replaceChild(frag, node);
      } else if (
        node.nodeType === Node.ELEMENT_NODE &&
        !['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.tagName)
      ) {
        Array.from(node.childNodes).forEach(walkTextNodes);
      }
    }

    walkTextNodes(container);

    // Scroll the first highlight into view
    const first = document.querySelector('.search-highlight');
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  })();

  // Resize for Match-Height and Slick-Slider glitch fix
  this.scroll_actions;
  $(window).bind('load', function(){
    $(window).trigger('resize');
    setTimeout(function(){ $(window).trigger('resize'); }, 500);
    this.scroll_actions;
  });
  $(document).ready(this.scroll_actions);
  $(window).scroll(this.scroll_actions);

  var scroll_actions = function() {
    $('.loading').each(function(){
      $(this).addClass('loaded');
    });
    $('.animate').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        $this.addClass('visible');
      }
    });
    $('.animate-1').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 100);
      }
    });
    $('.animate-2').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 200);
      }
    });
    $('.animate-3').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 300);
      }
    });
    $('.animate-4').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 400);
      }
    });
    $('.animate-5').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 500);
      }
    });
    $('.animate-6').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 600);
      }
    });
    $('.animate-7').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 700);
      }
    });
    $('.animate-8').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 800);
      }
    });
    $('.animate-9').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 900);
      }
    });
    $('.animate-10').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1000);
      }
    });
    $('.animate-11').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1100);
      }
    });
    $('.animate-12').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1200);
      }
    });
    $('.animate-13').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1300);
      }
    });
    $('.animate-14').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1400);
      }
    });
    $('.animate-15').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1500);
      }
    });
    $('.animate-16').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1600);
      }
    });
    $('.animate-17').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1700);
      }
    });
    $('.animate-18').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1800);
      }
    });
    $('.animate-19').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 1900);
      }
    });
    $('.animate-20').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 2000);
      }
    });
    $('.animate-21').each(function(){
      var $this = $(this);
      if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
        setTimeout(function(){
          $this.addClass('visible');
        }, 2100);
      }
    });
  }
});